/** The full Material Symbols font, which the apps' stylesheets register. */
export const MATERIAL_SYMBOLS_FULL_FONT_FAMILY = 'Material Symbols Rounded';
/** The subset of it holding the icons the code names, registered by `registerMaterialSymbolsSubset`. */
export const MATERIAL_SYMBOLS_SUBSET_FONT_FAMILY = 'Material Symbols Rounded Subset';
/**
 * The subset, or the full font while nothing has registered the subset. Fonts fall back per
 * character, and the subset has every letter, so an icon it lacks renders blank rather than reaching
 * the full font through this list; `Icon` switches such an icon to the full font itself.
 */
export const MATERIAL_SYMBOLS_FONT_STACK = `'${MATERIAL_SYMBOLS_SUBSET_FONT_FAMILY}', '${MATERIAL_SYMBOLS_FULL_FONT_FAMILY}'`;
